export default "__VITE_ASSET__5e8654e8__"